import React, { useState } from "react";
import toast from "react-hot-toast";
import Newvendor from "../../common/Newvendor";
import ConfirmationModal from "../../common/Confirmationmodal";

const VendorTagging = ({
  workOrderDetail,
  getVendorDetails,
  getSelectedVendor,
  vendorDetails,
  setVendorDetails,
  taggedVendors,
  setTaggedVendors,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [confirmModal, setConfirmModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchvalues, setSearchValues] = useState("");
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [tagVendorselected, setTagVendorSelected] = useState(null);

  const handleTagAPI = async () => {
    let payload = {
      serviceLogId: workOrderDetail?.id,
      vendorId: tagVendorselected?.id,
    };
    // return;
    try {
      const response = await fetch(`${apiUrl}/api/vehicleservicevendors`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Vendor Tag Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setConfirmModal(false)
        await getSelectedVendor(workOrderDetail?.id);
        await getVendorDetails(workOrderDetail?.cityId);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  // Bring tagged vendors to the top of the list
  const taggedVendorIds = new Set(
    (taggedVendors || []).map((tv) => tv?.vendorId),
  );
  const sortedVendorDetails = (vendorDetails || []).slice().sort((a, b) => {
    const aTagged = taggedVendorIds.has(a.id) ? -1 : 1;
    const bTagged = taggedVendorIds.has(b.id) ? -1 : 1;
    if (aTagged !== bTagged) return aTagged - bTagged;
    return (a?.name || "").toString().localeCompare((b?.name || "").toString());
  });

  const handleSearch = () => {
    if (!searchvalues) {
      setFilteredVendors([]);
      return;
    }

    const result = vendorDetails?.filter((item) =>
      item?.name?.toLowerCase().includes(searchvalues.toLowerCase()),
    );

    setFilteredVendors(result);
  };

  const handleClear = () => {
    setSearchValues("");
    setFilteredVendors([]);
  };

  return (
    <>
      {open && (
        <Newvendor
          open={open}
          setOpen={setOpen}
          getVendorsListAPI={getVendorDetails}
        />
      )}

      {confirmModal && (
        <ConfirmationModal
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          message={{
            title: "Confirm Tagging Vendor",
            content: "Are you sure you want to tag this vendor",
          }}
          handleConfirm={handleTagAPI}
        />
      )}

      <div className="min-h-screen bg-gray-100 p-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h1 className="text-xl font-bold text-gray-800">
                Vendor Tagging
              </h1>
            </div>

            <div className="flex items-center gap-4">
              <div class="flex items-center justify-end p-2">
                <div class="rounded-lg bg-gray-200 p-2">
                  <div class="flex">
                    <input
                      type="text"
                      className="w-full max-w-[160px] bg-white pl-2 text-base font-semibold outline-0"
                      value={searchvalues}
                      onChange={(e) => {
                        setSearchValues(e.target.value);
                      }}
                    />
                    <button
                      onClick={handleSearch}
                      className="bg-blue-500 p-2 rounded-tr-lg rounded-br-lg text-white font-semibold hover:bg-blue-800 transition-colors"
                    >
                      Search
                    </button>

                    <button
                      onClick={handleClear}
                      className="ml-2 bg-gray-400 p-2 rounded text-white"
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
              <button
                onClick={() => setOpen(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg shadow"
              >
                + Add Vendor
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {(filteredVendors.length > 0
              ? filteredVendors
              : sortedVendorDetails
            )?.map((vendor) => {
              const isTagged = taggedVendorIds.has(vendor.id) || false;

              return (
                <div
                  key={vendor.id}
                  className={`bg-white rounded-2xl shadow-md border transition-all duration-300 hover:shadow-xl ${
                    isTagged
                      ? "border-blue-500 ring-2 ring-blue-200"
                      : "border-gray-200"
                  }`}
                >
                  <div className="p-5 border-b">
                    <div className="flex justify-between items-start">
                      <h2 className="text-lg font-semibold text-gray-800">
                        {vendor.name}
                      </h2>
                      <p className="text-sm text-gray-500 mt-1">
                        {vendor.address}
                      </p>
                    </div>
                  </div>

                  <div className="p-5 space-y-2">
                    <div className="grid grid-cols-2">
                      <div>
                        <p className="text-sm text-gray-400">Contact Person</p>
                        <p className="font-medium text-gray-700">
                          {vendor.contactPerson}
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-gray-400">Email</p>
                        <p className="font-medium text-gray-700 break-all">
                          {vendor.contactEmail}
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-gray-400">Mobile</p>
                        <p className="font-medium text-gray-700">
                          {vendor.contactMobile}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-sm text-gray-400">GST No</p>
                        <p className="font-medium text-gray-700">
                          {vendor.gstNo}
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-gray-400">PAN No</p>
                        <p className="font-medium text-gray-700">
                          {vendor.panNo}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-4 mt-2">
                      <div>
                        <p className="text-sm text-gray-400">Credit Applied</p>
                        <p className="font-medium text-gray-700">
                          {vendor?.isCreditApplied === true
                            ? "Yes"
                            : vendor?.isCreditApplied === false
                              ? "No"
                              : "-"}
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-gray-400">Credit Amount</p>
                        <p className="font-medium text-gray-700">
                          {vendor?.creditAmount != null
                            ? `₹${Number(vendor.creditAmount).toLocaleString()}`
                            : vendor?.credit_amount != null
                              ? `₹${Number(vendor.credit_amount).toLocaleString()}`
                              : "-"}
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-gray-400">Days</p>
                        <p className="font-medium text-gray-700">
                          {vendor?.days ?? vendor?.creditDays ?? "-"}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="p-5 border-t flex justify-between items-center">
                    {/* <button className="text-blue-600 hover:text-blue-800 font-medium">
                    View Details
                  </button> */}

                    <button
                      onClick={() => {
                        !isTagged && setTagVendorSelected(vendor);
                        setConfirmModal(true);
                      }}
                      disabled={isTagged}
                      className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                        isTagged
                          ? "bg-green-600 text-white cursor-default"
                          : "bg-gray-200 hover:bg-blue-600 hover:text-white"
                      }`}
                    >
                      {isTagged ? "Tagged" : "Tag Vendor"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorTagging;
